
    import { Variables } from "../../../variables";
    import { Component, Vue } from "vue-property-decorator";
    import { accountApi } from "../../services/api/account/account";
    import { LoginCommand } from "../../services/api/models/LoginCommand.model";
    import { profileApi } from "../../services/api/profile/profile";
    import AnonymousLayout from "../../layouts/AnonymousLayout.vue";
    import FaceDetector from "../../components/FaceDetector.vue";
    import SelectProfile from "../../components/SelectProfile.vue";
    import TwoFactorCode from "../../components/TwoFactorCode.vue";

    @Component({
        components: { AnonymousLayout, FaceDetector, SelectProfile, TwoFactorCode },
    })
    export default class FacialRecognition extends Vue {

        get secretEncryptData() {
            return Variables.SecretEncryptData;
        }
        private returnUrl = "";
        private identification = "";
        private loading = false;
        private userErrors = [];
        private passErrors = [];
        private error_code = "";

        private errors: string[] = [];
        private msgError = false;
        private image = "";
        private validBiometric = "";
        private isPhotoTaken = false;

        private profiles = [];
        private modalProfile = false;
        private modalTwoFactor = false;

        $route: any;
        $router: any;

        async mounted() {
            this.returnUrl =
                (this.$route.query.returnUrl as string) ||
                (this.$route.query.ReturnUrl as string) ||
                "";
            this.identification = this.$route.query.identification;
        }

        encryptData(data: string, key: string): string {
            let encryptedData = "";
            for (let i = 0; i < data.length; i++) {
                const charCodeData = data.charCodeAt(i);
                const charCodeKey = key.charCodeAt(i % key.length);
                const encryptedCharCode = charCodeData ^ charCodeKey;
                encryptedData += String.fromCharCode(encryptedCharCode);
            }
            return btoa(encryptedData);
        }

        async onSubmit() {
            this.loading = true;
            this.userErrors = [];
            this.passErrors = [];
            this.errors = [];
            this.error_code = "";
            this.msgError = false;
            this.validBiometric = this.encryptData(
                `${this.image}`,
                `${this.secretEncryptData}`
            );

            const request = new LoginCommand(
                this.returnUrl,
                this.identification,
                "YeGB8W#h&x@{",
                true,
                "",
                "YeGB8W#h&x@{",
                this.validBiometric
            );

            try {
                const response = await accountApi.login(request);
                await this.redirectUrl(response, response.twoFactor);
                this.loading = false;
            } catch (err) {
                if (err?.response?.status === 400) {
                    let data = err.response.data;
                    if (data.Username !== undefined) {
                        this.userErrors = data.Username;
                    }
                    if (data.Password !== undefined) {
                        this.passErrors = data.Password;
                    }
                    if (data.errors !== undefined) {
                        this.errors = data.errors;
                    }
                    if (data.message !== undefined) {
                        this.errors.push(data.code);
                    }
                }
                this.msgError = true;
            }
        }

        photoTaken(isPhotoTaken: any, image: any) {
            this.isPhotoTaken = isPhotoTaken;
            this.image = image;
        }

        backLogin() {
            const video = document.getElementById("video") as HTMLVideoElement;

            if (video && video.srcObject) {
                const stream = video.srcObject as MediaStream;

                stream.getTracks().forEach((track: MediaStreamTrack) => {
                    track.stop();
                });
            }

            let url = this.$router.resolve({
                name: "Login",
            });

            if (this.returnUrl !== "") {
                url.href = `${url.href}?returnUrl=${this.returnUrl}`;
            }

            window.location.href = url.href;
        }

        async redirectUrl(response: any, twoFactor: any = false) {
            this.modalTwoFactor = false;
            this.modalProfile = false;

            if (twoFactor === true) {
                this.modalTwoFactor = true;
                return;
            }

            if (response.returnUrl.includes("additional%3Aprofile")) {
                this.profiles = await profileApi.getAdditionalProfiles();
                if (Object.entries(this.profiles).length > 0) {
                    this.modalProfile = true;
                    return;
                }
            }

            window.location.href = response.returnUrl;
        }
    }
